import React from 'react';
import { cn } from '../../../lib/utils';

export interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
}

/**
 * Header - Top section of ThreePane layout
 * Typically contains navigation, logo, and user controls
 */
export const Header = React.forwardRef<HTMLElement, HeaderProps>(
  ({ children, className, ...props }, ref) => {
    return (
      <header
        ref={ref}
        className={cn(
          'w-full border-b border-border bg-background',
          className
        )}
        {...props}
      >
        {children}
      </header>
    );
  }
);

Header.displayName = 'Header';
